import Bloodhound from './external-adapters/typeaheadJqueryAdapter';
import { getURLParam } from '../adapters/dupes/queryParams.js';

export function make() {
    // These URLs need to match the current page's URL, so we start them with a /
    const DISTRICTS_URL = '/common/districtSuggest.html?APIKey=' + dcAPIKey;

    const districtBloodhound = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        limit: 5,
        dupDetector: function (remote, local) {
            return remote.id === local.id;
        },
        remote: {
            url: DISTRICTS_URL,
            replace: function (url, query) {
                const uri = new Uri(url).replaceQueryParam('keywords', query);

                const state = getURLParam(window.location.href, 'state');
                if (state) {
                    uri.replaceQueryParam('state', state);
                }

                return uri.toString();
            },
        },
    });

    districtBloodhound.initialize();
    return districtBloodhound;
}
